import logService from '../logger/loggerService'

const LOG_PREFIX = '[SCR:Utils] appRunUuidStorage:'
const LS_APP_RUN_UUID_KEY = 'settings_appRunUuid'

const getAppRunUuidFromLS = () => localStorage.getItem(LS_APP_RUN_UUID_KEY)

const setAppRunUuid = (appRunUuid: string) => {
  if (!appRunUuid && getAppRunUuid()) {
    logService.debug(`${LOG_PREFIX} Reusing appRunUuid from local storage.`)

    return
  }

  localStorage.setItem(LS_APP_RUN_UUID_KEY, appRunUuid)
}

const getAppRunUuid = () => {
  const runUuid = getAppRunUuidFromLS()

  if (!runUuid) {
    logService.info(`${LOG_PREFIX} appRunUuid not found in local storage.`)

    return
  }

  return runUuid
}

export default {
  setAppRunUuid,
  getAppRunUuid
}
